"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slice = exports.Last = exports.First = exports.Current = exports.Distinct = exports.Flatten = exports.ForEach = exports.doProperIncludes = exports.doIncludes = exports.doContains = exports.IndexOf = exports.ToList = exports.SingletonFrom = exports.Filter = exports.Times = exports.doIntersect = exports.doExcept = exports.doUnion = exports.Exists = exports.List = void 0;
var expression_1 = require("./expression");
var builder_1 = require("./builder");
var util_1 = require("../util/util");
var comparison_1 = require("../util/comparison");
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List(json) {
        var _this = _super.call(this, json) || this;
        _this.elements = (0, builder_1.build)(json.element) || [];
        return _this;
    }
    Object.defineProperty(List.prototype, "isList", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    List.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.elements.map(function (item) { return item.execute(ctx); }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return List;
}(expression_1.Expression));
exports.List = List;
var Exists = /** @class */ (function (_super) {
    __extends(Exists, _super);
    function Exists(json) {
        return _super.call(this, json) || this;
    }
    Exists.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        list = _a.sent();
                        // if list exists and has non empty length we need to make sure it isnt just full of nulls
                        if (list) {
                            return [2 /*return*/, list.some(function (item) { return item != null; })];
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    return Exists;
}(expression_1.Expression));
exports.Exists = Exists;
// Equal is completely handled by overloaded#Equal
// NotEqual is completely handled by overloaded#Equal
// Delegated to by overloaded#Union
function doUnion(a, b) {
    var distinct = doDistinct(a.concat(b));
    return removeDuplicateNulls(distinct);
}
exports.doUnion = doUnion;
// Delegated to by overloaded#Except
function doExcept(a, b) {
    var distinct = doDistinct(a);
    var setList = removeDuplicateNulls(distinct);
    return setList.filter(function (item) { return !doContains(b, item, true); });
}
exports.doExcept = doExcept;
// Delegated to by overloaded#Intersect
function doIntersect(a, b) {
    var distinct = doDistinct(a);
    var setList = removeDuplicateNulls(distinct);
    return setList.filter(function (item) { return doContains(b, item, true); });
}
exports.doIntersect = doIntersect;
// ELM-only, not a product of CQL
var Times = /** @class */ (function (_super) {
    __extends(Times, _super);
    function Times() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Times;
}(expression_1.UnimplementedExpression));
exports.Times = Times;
// ELM-only, not a product of CQL
var Filter = /** @class */ (function (_super) {
    __extends(Filter, _super);
    function Filter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Filter;
}(expression_1.UnimplementedExpression));
exports.Filter = Filter;
var SingletonFrom = /** @class */ (function (_super) {
    __extends(SingletonFrom, _super);
    function SingletonFrom(json) {
        return _super.call(this, json) || this;
    }
    SingletonFrom.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null && arg.length > 1) {
                            throw new Error("IllegalArgument: 'SingletonFrom' requires a 0 or 1 arg array");
                        }
                        else if (arg != null && arg.length === 1) {
                            return [2 /*return*/, arg[0]];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return SingletonFrom;
}(expression_1.Expression));
exports.SingletonFrom = SingletonFrom;
var ToList = /** @class */ (function (_super) {
    __extends(ToList, _super);
    function ToList(json) {
        return _super.call(this, json) || this;
    }
    ToList.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            return [2 /*return*/, [arg]];
                        }
                        else {
                            return [2 /*return*/, []];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return ToList;
}(expression_1.Expression));
exports.ToList = ToList;
var IndexOf = /** @class */ (function (_super) {
    __extends(IndexOf, _super);
    function IndexOf(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        _this.element = (0, builder_1.build)(json.element);
        return _this;
    }
    IndexOf.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var index, src, el, i, itm;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.source.execute(ctx)];
                    case 1:
                        src = _a.sent();
                        return [4 /*yield*/, this.element.execute(ctx)];
                    case 2:
                        el = _a.sent();
                        if (src == null || el == null) {
                            return [2 /*return*/, null];
                        }
                        for (i = 0; i < src.length; i++) {
                            itm = src[i];
                            if ((0, comparison_1.equals)(itm, el)) {
                                index = i;
                                break;
                            }
                        }
                        if (index != null) {
                            return [2 /*return*/, index];
                        }
                        else {
                            return [2 /*return*/, -1];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return IndexOf;
}(expression_1.Expression));
exports.IndexOf = IndexOf;
// Indexer is completely handled by overloaded#Indexer
// Delegated to by overloaded#Contains and overloaded#In
function doContains(container, item, nullEquivalence) {
    if (nullEquivalence === void 0) { nullEquivalence = false; }
    return container.some(function (element) { return (0, comparison_1.equals)(element, item) || (nullEquivalence && element == null && item == null); });
}
exports.doContains = doContains;
// Delegated to by overloaded#Includes and overloaded@IncludedIn
function doIncludes(list, sublist) {
    return sublist.every(function (x) { return doContains(list, x); });
}
exports.doIncludes = doIncludes;
// Delegated to by overloaded#ProperIncludes and overloaded@ProperIncludedIn
function doProperIncludes(list, sublist) {
    return list.length > sublist.length && doIncludes(list, sublist);
}
exports.doProperIncludes = doProperIncludes;
// ELM-only, not a product of CQL
var ForEach = /** @class */ (function (_super) {
    __extends(ForEach, _super);
    function ForEach() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ForEach;
}(expression_1.UnimplementedExpression));
exports.ForEach = ForEach;
var Flatten = /** @class */ (function (_super) {
    __extends(Flatten, _super);
    function Flatten(json) {
        return _super.call(this, json) || this;
    }
    Flatten.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if ((0, util_1.typeIsArray)(arg) && arg.every(function (x) { return (0, util_1.typeIsArray)(x); })) {
                            return [2 /*return*/, arg.reduce(function (x, y) { return x.concat(y); }, [])];
                        }
                        else {
                            return [2 /*return*/, arg];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Flatten;
}(expression_1.Expression));
exports.Flatten = Flatten;
var Distinct = /** @class */ (function (_super) {
    __extends(Distinct, _super);
    function Distinct(json) {
        return _super.call(this, json) || this;
    }
    Distinct.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        result = _a.sent();
                        if (result == null) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, doDistinct(result)];
                }
            });
        });
    };
    return Distinct;
}(expression_1.Expression));
exports.Distinct = Distinct;
function doDistinct(list) {
    var distinct = [];
    list.forEach(function (item) {
        var isNew = distinct.every(function (seenItem) { return !(0, comparison_1.equals)(item, seenItem); });
        if (isNew) {
            distinct.push(item);
        }
    });
    return removeDuplicateNulls(distinct);
}
function removeDuplicateNulls(list) {
    // Remove duplicate null elements
    var firstNullFound = false;
    var setList = [];
    for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
        var item = list_1[_i];
        if (item !== null) {
            setList.push(item);
        }
        else if (item === null && !firstNullFound) {
            setList.push(item);
            firstNullFound = true;
        }
    }
    return setList;
}
// ELM-only, not a product of CQL
var Current = /** @class */ (function (_super) {
    __extends(Current, _super);
    function Current() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Current;
}(expression_1.UnimplementedExpression));
exports.Current = Current;
var First = /** @class */ (function (_super) {
    __extends(First, _super);
    function First(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        return _this;
    }
    First.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var src;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.source.exec(ctx)];
                    case 1:
                        src = _a.sent();
                        if (src != null && (0, util_1.typeIsArray)(src) && src.length > 0) {
                            return [2 /*return*/, src[0]];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return First;
}(expression_1.Expression));
exports.First = First;
var Last = /** @class */ (function (_super) {
    __extends(Last, _super);
    function Last(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        return _this;
    }
    Last.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var src;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.source.exec(ctx)];
                    case 1:
                        src = _a.sent();
                        if (src != null && (0, util_1.typeIsArray)(src) && src.length > 0) {
                            return [2 /*return*/, src[src.length - 1]];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Last;
}(expression_1.Expression));
exports.Last = Last;
var Slice = /** @class */ (function (_super) {
    __extends(Slice, _super);
    function Slice(json) {
        var _this = _super.call(this, json) || this;
        _this.source = (0, builder_1.build)(json.source);
        _this.startIndex = (0, builder_1.build)(json.startIndex);
        _this.endIndex = (0, builder_1.build)(json.endIndex);
        return _this;
    }
    Slice.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var src, startIndex, endIndex, start, end;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.source.exec(ctx)];
                    case 1:
                        src = _a.sent();
                        if (!(src != null && (0, util_1.typeIsArray)(src))) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.startIndex.exec(ctx)];
                    case 2:
                        startIndex = _a.sent();
                        return [4 /*yield*/, this.endIndex.exec(ctx)];
                    case 3:
                        endIndex = _a.sent();
                        start = startIndex != null ? startIndex : 0;
                        end = endIndex != null ? endIndex : src.length;
                        if (src.length === 0 || start < 0 || end < 0 || end < start) {
                            return [2 /*return*/, []];
                        }
                        return [2 /*return*/, src.slice(start, end)];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    return Slice;
}(expression_1.Expression));
exports.Slice = Slice;
// Length is completely handled by overloaded#Length
//# sourceMappingURL=list.js.map